import React from 'react'
import { Dialog, DialogContent, IconButton, Box, Tab } from '@material-ui/core';
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import PageviewIcon from '@material-ui/icons/Pageview';
import { useSelector } from 'react-redux';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { useState } from 'react';

const EditButtonNomenclador = ({ Form, SecondForm, item, handleSave, handleSaveCuentas,permiso, sizeModal = "md", title }) => {
    const { permisos: permisosUser } = useSelector(state => state.auth)
    const { cuentasNomenclador } = useSelector(state => state.nomencladores)
    const [open, setOpen] = useState(false)
    const [value, setValue] = useState('1')

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setValue('1');
    };
    const handleChange = (e, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <IconButton
                aria-label="Editar"
                onClick={() => handleClickOpen()}
            >
                <PageviewIcon sx={{ fontSize: "2rem" }} color="primary" />
            </IconButton>
            {
                open &&
                <Dialog open={open} onClose={handleClose} fullWidth maxWidth={sizeModal}>
                    <DialogContent>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="Editar" value='1' />
                                    <Tab label="Cuentas Contables" value='2' />
                                </TabList>
                            </Box>

                            <TabPanel value='1'>
                                <Form
                                    formData={item}
                                    handleSubmit={(data) => handleSave(data, handleClose, false)}
                                    handleCancel={handleClose}
                                    editable={(permiso === null || validarSoloUnPermiso(permisosUser, permiso))}
                                />
                            </TabPanel>
                            <TabPanel value='2'>
                                <SecondForm 
                                    idNomenclador={item.id}
                                    codNom={item.codNomPlano}
                                    formData={cuentasNomenclador[0]}
                                    handleSubmit={(data) => handleSave(data, handleClose, true)}
                                    editable={(permiso === null || validarSoloUnPermiso(permisosUser, permiso))}
                                    handleCancel={handleClose}
                                />
                            </TabPanel>
                        </TabContext>
                    </DialogContent>
                </Dialog>   
            }
        </>
    )
}

export default EditButtonNomenclador

